import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TranslocoModule } from '@ngneat/transloco';
import { environment } from '@evasys/globals/evasys/environments/environment';
import { NgModule } from '@angular/core';
import { SharedCoreModule, TranslateService } from '@evasys/shared/core';
import { ApplicationInit } from './app.init';
import { EvasysTranslateLoader } from './app-translate.loader';

@NgModule({
	exports: [TranslocoModule],
	imports: [SharedCoreModule],
	providers: [
		{
			provide: TRANSLOCO_CONFIG,
			useValue: {
				availableLangs: [
					'de_edu',
					'de_com',
					'de_qmc',
					'en_edu',
					'en_com',
					'en_qmc',
					'es_edu',
					'es_com',
					'es_qmc',
					'fr_edu',
					'fr_com',
					'fr_qmc',
					'hu_edu',
					'hu_com',
					'hu_qmc',
					'se_edu',
					'se_com',
					'se_qmc',
				],
				reRenderOnLangChange: true,
				prodMode: environment.production,
			},
			deps: [ApplicationInit],
		},
		{
			provide: TRANSLOCO_LOADER,
			useClass: EvasysTranslateLoader,
			deps: [TranslateService],
		},
	],
})
export class AppTranslationModule {}
